import { SiteSettings } from "@customTypes/SiteSettings";
import uniq from "lodash/uniq";
import { HightLight, Results } from "../CoveoSearchComponent";

interface DefaultResultsTemplateProps {
  siteSettings?: SiteSettings;
  result: Results;
  handleSelect?: () => void;
}

const getHihlightedText = (
  _text: string,
  highlights?: HightLight[],
  coverText?: string
) => {
  const text = coverText || _text;
  if (!highlights || highlights.length === 0) {
    return text;
  }

  let result = _text;
  const replaceWords = highlights.map((highlight) =>
    text.substring(highlight.offset, highlight.offset + highlight.length)
  );

  uniq(replaceWords.sort((a, b) => b.length - a.length)).forEach((word) => {
    const regexWord = new RegExp(`\\b${word}\\b`, "gi");
    result = result.replaceAll(regexWord, `<strong>${word}</strong>`);
  });

  return result;
};

export const DefaultResultsTemplate = (props: DefaultResultsTemplateProps) => {
  const { result, siteSettings } = props;

  function getGlobalSearchTagTextAndPathCollection(collection) {
    const data: any[] = [];

    collection.forEach((e) => {
      const item = {};
      item["key"] = e.split("-")[0];
      item["phrase"] = e.split("-")[1];
      data.push(item);
    });

    return data;
  }

  const TagTextAndPathCollection = getGlobalSearchTagTextAndPathCollection(
    siteSettings?.globalSearchTagTextAndPath
  );

  const itemPath =
    result.ClickUri != null
      ? result.ClickUri.split("/")[3].split("-").join(" ")
      : "";

  function getPhraseAndPath(searchSectionDisplayNames, itemPath) {
    const item = searchSectionDisplayNames.find(
      (p) => p.key.toLowerCase().slice(1) === itemPath
    );

    if (item) {
      const tagObject = {};
      tagObject["phrase"] = item.phrase;
      tagObject["path"] = result?.ClickUri?.split("/")[3];

      return tagObject;
    }
  }

  const tagObject = getPhraseAndPath(TagTextAndPathCollection, itemPath);
  return (
    <>
      <div className="coveo-result">
        <div>
          <a className="coveo-link" href={result.clickUri} onClick={props.handleSelect}>
            {result.title && <h3 className="h3">{result.title}</h3>}
          </a>
          {result.raw.pagedescription && (
            <p className="page-description">
              <span
                dangerouslySetInnerHTML={{
                  __html: getHihlightedText(
                    result.raw.pagedescription,
                    result.excerptHighlights,
                    result.excerpt
                  ),
                }}
              />
            </p>
          )}
        </div>

        {tagObject !== undefined && (
          <div className="component tag">
            <a href={`/${tagObject["path"]}`}>{tagObject["phrase"]}</a>
          </div>
        )}
      </div>
    </>
  );
};

export default DefaultResultsTemplate;
